module.exports = __webpack_public_path__ + "media/videos/investment-6/video-275a3c5137b047a5d65972a4343f39ec.mp4";